<template>
  <qx-card-form title="外调车及承包车成本">
    <span class="tip" slot="titleLeft">
      <el-tooltip content="如本线路有外请车的情况，或者自有车承包的情况，需要填写一下两个指标">
        <i class="el-icon-question warning"></i>
      </el-tooltip>
    </span>
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <span class="tip" slot="guidePriceTip">
        <el-tooltip content="填写本线路外请车或承包车的最高运费，如果开单时的运费或承包价超过该费用时，需要审批后才生效；如果为空，系统默认为没有上线，无需审批">
          <i class="el-icon-question warning"></i>
        </el-tooltip>
      </span>
      <span class="tip" slot="guideMerchantTip">
        <el-tooltip content="填写本线路外请车或承包车的标准运费，开单时的 运费或承包价默认为该费用，可手动调整">
          <i class="el-icon-question warning"></i>
        </el-tooltip>
      </span>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        inline: true,
        form: [
          {
            label: '运费上限',
            value: 'guidePrice',
            type: 'input',
            width: '240px',
          },
          {
            label: '运费标准',
            value: 'guideMerchant',
            type: 'input',
            width: '240px',
          },
        ],
        rules: {
          // guidePrice: [ // 运费上限
          //   { required: true, message: '请输入运费上限', trigger: 'blur' },
          // ],
          // guideMerchant: [ // 运费标准
          //   { required: true, message: '请输入运费标准', trigger: 'blur' },
          // ],
        },
      },
    };
  },
  methods: {
    async cacheData () {
      const formData = await this.$refs.baseForm.getVal();
      return formData;
    },

    async sub () {
      const formData = await this.$refs.baseForm.sub();
      return formData;
    },
    init (data = {}) {
      const res = {
        guidePrice: data.guidePrice,
        guideMerchant: data.guideMerchant,
      };
      this.$refs.baseForm.setVal('form', res);
    },
  },
};
</script>

<style scoped lang="scss">
.tip{
  margin-left: 16px;
  color: #999;
}
</style>
